import { useMantineTheme } from "@mantine/core";

function KeyCombinationDoc() {
    const theme = useMantineTheme();
    const viewDocument = (e) => {
        e.preventDefault();
        window.api.mb_ipcRenderer.sendMsg("mb_open_link_web_browser", {
            url: "https://docs.hidemium.io/automation-user-manual/keyboard",
        });
    };
    return (
        <a
            style={{
                fontSize: 13,
                color: theme.colorScheme === "dark" ? theme.colors.gray[0] : "blue",
            }}
            href="#"
            onClick={viewDocument}
        >
            Click here for keyboard shortcuts documentation (Ctrl / ⌘ + A, C, V, R)
        </a>
    );
}

export default KeyCombinationDoc;
